import { render, staticRenderFns } from "./LoaderAi.vue?vue&type=template&id=7b013f9a&scoped=true&"
import script from "./LoaderAi.vue?vue&type=script&lang=js&"
export * from "./LoaderAi.vue?vue&type=script&lang=js&"
import style0 from "./LoaderAi.vue?vue&type=style&index=0&id=7b013f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b013f9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b013f9a')) {
      api.createRecord('7b013f9a', component.options)
    } else {
      api.reload('7b013f9a', component.options)
    }
    module.hot.accept("./LoaderAi.vue?vue&type=template&id=7b013f9a&scoped=true&", function () {
      api.rerender('7b013f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Register/components/LoaderAi.vue"
export default component.exports